import Service from "@/services";

// Verification store module
const state = {
  verificationData: null,
  status: "",
  error: null,
  loading: false,
};

// Getters
const getters = {
  verificationData: (state) => state.verificationData,
  isVerificationLoading: (state) => state.loading,
  verificationStatus: (state) => state.status,
  verificationError: (state) => state.error,
};

// Actions
const actions = {
  // Save verification data
  async saveVerificationData({ commit }, verificationData) {
    commit("VERIFICATION_REQUEST");
    try {
      const response = await Service().post(
        "../api/src/verification/submit",
        verificationData
      );

      if (response.data && response.data.status) {
        commit("VERIFICATION_SUCCESS", response.data.data);
        return Promise.resolve(response);
      } else {
        // If API returns status: false, treat as an error
        commit("VERIFICATION_ERROR", response.data);
        return Promise.resolve(response); // Still resolve but with error state
      }
    } catch (error) {
      console.error("Error submitting verification:", error);
      commit("VERIFICATION_ERROR", error);
      return Promise.reject(error);
    }
  },

  // Save face verification data
  async saveFaceVerificationData({ commit }, { formData, onProgress } = {}) {
    commit("VERIFICATION_REQUEST");
    try {
      const response = await Service().post(
        "../api/src/verification/face/submit",
        formData,
        {
          onUploadProgress: (event) => {
            if (onProgress && event.total) {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          },
        }
      );

      if (response.data && response.data.status) {
        commit("VERIFICATION_SUCCESS", response.data.data);
        return Promise.resolve(response);
      } else {
        // If API returns status: false, treat as an error
        commit("VERIFICATION_ERROR", response.data);
        return Promise.resolve(response); // Still resolve but with error state
      }
    } catch (error) {
      console.error("Error submitting face verification:", error);
      commit("VERIFICATION_ERROR", error);
      return Promise.reject(error);
    }
  },

  // Reset verification form and state
  resetVerification({ commit }) {
    commit("RESET_VERIFICATION");
  },
};

// Mutations
const mutations = {
  VERIFICATION_REQUEST(state) {
    state.status = "loading";
    state.loading = true;
    state.error = null;
  },

  VERIFICATION_SUCCESS(state, data) {
    state.status = "success";
    state.loading = false;
    state.verificationData = data;
    state.error = null;
  },

  VERIFICATION_ERROR(state, error) {
    state.status = "error";
    state.loading = false;

    // Handle different error formats
    if (error && error.response) {
      state.error = error.response.data;
    } else if (error && typeof error === "object") {
      state.error = error.message || error;
    } else {
      state.error = error || "An unknown error occurred";
    }
  },

  RESET_VERIFICATION(state) {
    state.verificationData = null;
    state.status = "";
    state.error = null;
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
